import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { ColumnMode, NgxDatatableModule, SelectionType } from '@swimlane/ngx-datatable';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { EditCollaboratorTypeComponent } from 'src/app/components/edit-collaborator-type/edit-collaborator-type.component';
import { CollaboratorType } from 'src/models';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { AuthService } from 'src/services/auth.service';
import { CollaboratorTypesService } from 'src/services/collaborator-types.service';
import { MessageService } from 'src/services/message.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NgxDatatableModule, SharedPipesModule],
  selector: 'app-collaborator-types-list',
  templateUrl: './collaborator-types-list.component.html',
  styleUrls: ['./collaborator-types-list.component.scss'],
})
export class CollaboratorTypesListComponent implements OnInit, OnDestroy {
  collaboratorTypes: Partial<CollaboratorType>[] = [];
  filteredCollaboratorTypes: Partial<CollaboratorType>[] = [];

  searchText: string;
  isLoading = false;
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  pageCount = 1;
  pageSize = 50;
  routerSub: Subscription;

  constructor(
    public authService: AuthService,
    private modalCtrl: ModalController,
    private collaboratorTypesService: CollaboratorTypesService,
    private msgSrvc: MessageService,
    private router: Router,
    private location: Location,
  ) {}

  async ngOnInit() {
    const currentPath = this.location.path();

    this.routerSub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd && currentPath === e.url))
      .subscribe(async () => {
        this.isLoading = true;

        await Promise.all([this.getCollaboratorTypes()]);

        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }

  async getCollaboratorTypes() {
    try {
      const collaboratorTypesResponse = await this.collaboratorTypesService.list({
        limit: null,
        order: ['name'],
        descending: false,
      });

      this.collaboratorTypes = collaboratorTypesResponse.data;
      this.collaboratorTypesService.cachedCollaboratorTypes = this.collaboratorTypes;
      this.filteredCollaboratorTypes = this.collaboratorTypes;
    } catch (err) {
      this.msgSrvc.showError(err);
    }
  }

  showNextPage() {
    this.pageCount += 1;
  }

  handleFilters() {
    this.filteredCollaboratorTypes = this.collaboratorTypes;

    const term = this.searchText?.trim().toLowerCase();

    if (term) {
      this.filteredCollaboratorTypes = this.collaboratorTypes.filter((collaboratorType) =>
        collaboratorType.name.toLowerCase().includes(term),
      );
    }
  }

  async createCollaboratorType() {
    const modal = await this.modalCtrl.create({
      component: EditCollaboratorTypeComponent,
      componentProps: {},
    });

    modal.present();

    modal.onDidDismiss().then(() => {
      this.getCollaboratorTypes();
    });
  }

  async editCollaboratorType(id: string) {
    const modal = await this.modalCtrl.create({
      component: EditCollaboratorTypeComponent,
      componentProps: {
        id,
      },
    });

    modal.present();

    modal.onDidDismiss().then(() => {
      this.getCollaboratorTypes();
    });
  }
}
